var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider",
    clipPath: "url(#clip0_626_14167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14355 0.986543C1.14355 0.871006 1.23722 0.777344 1.35275 0.777344H4.69995C4.81549 0.777344 4.90915 0.871006 4.90915 0.986543V4.75214C4.90915 4.83567 4.85945 4.9112 4.78273 4.94426C4.70601 4.97732 4.61698 4.96156 4.55626 4.90419L3.02635 3.45842L1.49644 4.90419C1.43572 4.96156 1.34669 4.97732 1.26997 4.94426C1.19325 4.9112 1.14355 4.83567 1.14355 4.75214V0.986543ZM1.56195 1.19574V4.26661L2.88267 3.01854C2.9633 2.94234 3.0894 2.94234 3.17004 3.01854L4.49075 4.26661V1.19574H1.56195Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_14167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.02079,
    height: 5.02079,
    fill: "white",
    transform: "translate(0.516113 0.358887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.41c0dfbbeae0a693565993fc002c9910.svg";
export { ForwardRef as ReactComponent };